import React from 'react';
import 'isomorphic-fetch';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

const PHOTOS = [
  {
    src: '/images/building/livingroom.jpg',
    width: 720,
    height: 960,
  },
  {
    src: '/images/building/entry.jpg',
    width: 720,
    height: 960,
  },
  {
    src: '/images/building/hallway.jpg',
    width: 720,
    height: 960,
  },
  {
    src: '/images/building/bathroom.jpg',
    width: 720,
    height: 960,
  }
];

export default class extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      photos: [],
    }
  }

  componentDidMount(){

    fetch('https://graph.facebook.com/hopedalecottage/photos?access_token=1060624467289271%7C4d65168faf735397427bda4bf31245f6&type=uploaded').then(res => 
    res.json()
    ).then(data => {
      this.setState({
        photos: data.data
      })
    }).then(()=>{
      var grid = document.querySelector('#gallery');
      var msnry = new Masonry( grid, {
        itemSelector: '.picture',
      });
  
      imagesLoaded( grid ).on( 'progress', function() {
        msnry.layout();
      });
    })

  }
  render() {
    const {photos} = this.state;
    return (
      <div id="main">

          <section  id="header" style={{
            backgroundImage: 'url(images/sign-new.jpg)'
          }}>
            <div id="slogan">Difficult decision...easy choice.</div>
          </section>
          <section className="navy">

              <div className="container">
                  <h1>
                      Hopedale Cottage
                  </h1>
                  <p>
                      The Hopedale Cottage Assisted Living community is conveniently located in Ozark, MO - just minutes from Springfield.

                    </p><p> If you are interested in learning more about our facility please call Jim Edwards, Owner, at 417- 581-7278.
                  </p>



                  <p>
                      With 12 nicely appointed private rooms, it offers a serene and comforting setting for our residents. For those residents that tend to wander, we offer a secured environment to insure their safety and your peace of mind.
                  </p>
              </div>
          </section>
          <section className="tan" id="services-section" style={{backgroundImage: 'url(images/nicelady.jpg)', backgroundRepeat:'no-repeat', backgroundSize:'contain', backgroundPosition: 'center right'}}>
              <div className="container">
                <div id="services">
                  <h2>Services we offer:</h2>
                  <ul>
                      <li>Medication</li>
                      <li>On site nurse</li>
                      <li>
                          Medical Director/Physician directing medical care of residents
                      </li>
                      <li>
                          Assistance with activities of daily living and personal care that include: assistance with dressing, grooming, bathing, nail care and toileting as needed.
                      </li>
                      <li>
                          Housekeeping
                      </li>
                      <li>
                          Laundry
                      </li>
                      <li>
                          3 Nutritious meals a day including snacks
                      </li>
                      <li>
                          Activities, including special events in the community
                      </li>
                      <li>
                          Physical, occupational, and speech therapy available
                      </li>
                      <li>
                          Hair salon
                      </li>
                  </ul>

             </div>
              </div>
          </section>
          <section className="navy">
            <div className="container">
              <h2 style={{marginBottom: '20px'}}>Activity Calendar</h2>
              <iframe title="calendar" src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showNav=0&amp;showDate=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;mode=AGENDA&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=f7vj7qje9vt72g07qtaau2sb8o%40group.calendar.google.com&amp;color=%235229A3&amp;ctz=America%2FChicago" style={{border: '0', margin:'0 auto', display:'block'}} width="90%" height="600" frameBorder="0" scrolling="no"></iframe>
            </div>
          </section>
          <section className="tan">
              <div className="container">

                  <h2>Why Hopedale?</h2>
                  <p>
                      Hopedale Cottage is licensed by the State of Missouri as a Level II assisted living community that is able to care for residents that need more than minimal assistance. This enables many residents to remain in our community and "age in place" avoiding the transfer to a nursing home setting.
                  </p>
                  <h2>Directions</h2>
                  <p>1314 W School Street, Ozark MO</p>
                  <iframe
                    width="95%"
                    height="450"
                    style={{
                      display: 'block',
                      margin: '0 auto'
                    }}
                    frameBorder="0"
                    title="map"
                    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFKEJt1L2wgmZZAUTbWaTxDOMfaua9xs4&q=1314+W+School+Street,Ozark+MO" allowFullScreen>
                  </iframe>
              </div>
          </section>
          <section className="navy">
            <div className="container">
              <h2>Photos</h2>
              {PHOTOS.map((photo, i)=>{
                return (
                  <div key={i} style={{
                    display: 'inline-block',
                    width: '50%'
                  }}>
                    <img src={photo.src} alt="" style={{
                      maxWidth: '99%'
                    }}/>
                  </div>
                )
              })}

            </div>
          </section>
          <section className="tan">
              <div className="container">

                  <h2>Floorplan</h2>
                  <p><img alt="floorplan" src="/images/floorplan.png" style={{
                    maxWidth: '100%'
                  }}/>
                  </p>
              </div>
          </section>
          <section className="navy">
            <div className="container">
              <a href="https://www.facebook.com/hopedalecottage" style={{
                display: 'inline-block',
                padding: '30px',
                background: '#3B5998',
                color: 'white',
                marginBottom: '30px',
                textDecoration: 'none'
              }}>Check us out on Facebook!</a>
            <div id="gallery" >

            {photos && photos.map((photo, i) => (
              <img alt="" key={i} className="picture" src={`https://graph.facebook.com/${photo.id}/picture`} />
            ))}
            </div>
            </div>
          </section>
          <style jsx>
              {  `
                  .picture {
                    width: 50%;
                  }
                  @media (max-width: 670px) {
                    .picture {
                      width: 50%;
                    }
                  }
                  #main {
                      background: navy;
                      position: absolute;
                      width: 100%;
                      height: 100%;
                      color: tan;
                      font-family: 'Roboto Condensed', sans-serif;
                      font-size: 22px;
                  }

                  .container {
                      max-width: 970px;
                      margin: 0 auto;
                  }
                  #services {
                    width: 60%;
                  }
                  h1, h2 {
                    margin: 0;
                    font-family: 'Satisfy', cursive;
                    padding: 0;
                  }
                  section.tan {
                      background: tan;
                      color: navy;
                  }
                  section.navy {
                      background: navy;
                      color: tan;
                  }
                  section {
                      padding: 80px 40px;
                  }
                  #top {
                    color: white;
                    font-size: 20px;
                    padding: 10px 0;
                    text-align: center;
                    text-shadow: 3px 3px 3px black;
                  }
                  #slogan {
                    font-family: 'Satisfy', cursive;
                    position: absolute;
                    color: tan;
                    font-size: 44px;
                    text-shadow: 0px 3px 2px white;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    left: 50%;
                    text-align: center;
                    width: 100%;
                  }
                  #call {
                    background: tan;
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    padding: 20px;
                    color: navy;
                  }
                  #header {
                    background-size: cover;
                    padding-bottom: 30%;
                    position: relative;
                    background-position: center center;
                    background-repeat: no-repeat;
                  }
                  @media (max-width: 670px) {
                    #services-section {
                      background-image: none!important;
                    }
                    #services {
                      width: 100%;
                    }
                    #header {
                      padding-bottom: 0%;
                      height: 220px;
                    }
                    #slogan {
                      font-size: 22px;
                      width: 100%;
                    }
                    #call {
                      font-size: 18px;
                      text-align: center;

                    }
                  }
                   `
              }</style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/home.js